module.exports = __webpack_public_path__ + "img/client5.b2350f20.svg";